// extracted by mini-css-extract-plugin
export default {"container":"boardPost_container__0lBox","title":"boardPost_title__KTY1t","editor":"boardPost_editor__OtqRS","btnRgn":"boardPost_btnRgn__lpraD","cancel":"boardPost_cancel__7onMm"};